import { route, tag, type PageTour } from '../pageTour';

export const attendanceUnknownFacesTour: PageTour = {
  id: 'page-attendance-unknown-faces',
  version: 1,
  title: 'Unknown Faces',
  summary: 'Faces seen but not recognised — enrol or dismiss them.',
  match: route('/attendance/unknown-faces'),
  steps: [
    {
      target: tag('attendance-toolbar'),
      title: 'Unknown faces',
      description: 'How many faces the cameras saw but could not match to an employee.',
      side: 'bottom',
    },
    {
      target: tag('attendance-unknown-grid'),
      title: 'Register or link',
      description: 'Register a face as a new employee, or link it to someone already enrolled to help the cameras recognise them next time.',
      side: 'top',
      anyPermission: ['attendance.register_employee', 'attendance.link_employee'],
    },
    {
      target: tag('attendance-unknown-refresh'),
      title: 'Refresh',
      description: 'Reload to see the newest unknown faces.',
      side: 'bottom',
    },
  ],
};
